<div class="popup">
  <div class="title" style="margin: 20px 0 0 20px">Change tenant</div>
  <div class="subtitle">Select from existing tenants.</div>
  <div class="field-class">
    <span class="field-label">Tenant</span>
    <p-dropdown 
      [options]="tenantList" 
      [filter]="true"
      filterBy="name"
      displayProperty="id"
      [(ngModel)]="currTenant"
      [ngModelOptions]="{standalone: true}"
      optionLabel="name"
      [virtualScroll]="true" 
      [virtualScrollItemSize]="38"
      [style]="{'width': '100%', 'height': '28px', 'font-size': '14px', 'background-color': 'var(--list-bg-color)', 'padding-left': '5px', 'color': 'var(--text-color)'}"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption >
        <div style="margin-top: -6px;">
          {{currTenant.name}}
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <div class="property-field">
    <div class="property-label">{{ 'tenantName' | translate }}</div>
    <div class="property-value">{{ currTenant?.name || "No tenant name" }}</div>
  </div>
  <div class="property-field">
    <div class="property-label">ID</div>
    <div class="property-value">{{ currTenant?.id || "No tenant ID" }}</div>
  </div>
  <div class="property-field">
    <div class="property-label">{{'expDateShort' | translate}}</div>
    <div class="property-value">{{ currTenant?.expiration_date || "No exp. date" }}</div>
  </div>
  <div class="button-area flex">
    <button [mat-dialog-close] class="cancel-button outline-none h-10">Cancel</button>
    <button class="save-button outline-none h-10" (click)="onSave()">Save</button>
  </div>
</div>
      